import React from 'react'
import { BaseIconProps, getHexColor } from '../utils'

interface StarRatingIconProps {
  size?: number
  className?: string
  variant?: 'filled' | 'empty'
}

export const StarRatingIcon: React.FC<StarRatingIconProps & BaseIconProps> = ({
  size = 18,
  className,
  variant = 'filled',
}) => {
  // Hardcoded colors based on variant
  const colors = {
    filled: {
      color1: '#FFDBB4',
      color2: '#D47319',
    },
    empty: {
      color1: '#E5E7EB', // core-gray-200
      color2: '#E5E7EB', // same color for solid appearance
    },
  }

  const { color1, color2 } = colors[variant]
  const gradientId = `star-${variant}`
  return (
    <svg
      width={size}
      height={size}
      className={className}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 14.0664L5.36455 16.3595C5.20395 16.4666 5.03605 16.5124 4.86085 16.4971C4.68565 16.4818 4.53234 16.4207 4.40094 16.3137C4.26954 16.2067 4.16734 16.0729 4.09434 15.9124C4.02134 15.7519 4.00674 15.5722 4.05054 15.3735L5.01415 11.0395L1.79481 8.12717C1.64881 7.98958 1.55756 7.83289 1.52106 7.65708C1.48456 7.48127 1.49551 7.30929 1.55391 7.14112C1.61231 6.97296 1.69991 6.83537 1.81671 6.72836C1.93351 6.62135 2.09412 6.55255 2.29852 6.52198L6.54717 6.13214L8.18969 2.05035C8.26269 1.8669 8.37584 1.72931 8.52914 1.63759C8.68245 1.54586 8.8394 1.5 9 1.5C9.1606 1.5 9.31755 1.54586 9.47086 1.63759C9.62416 1.72931 9.73731 1.8669 9.81031 2.05035L11.4528 6.13214L15.7015 6.52198C15.9059 6.55255 16.0665 6.62135 16.1833 6.72836C16.3001 6.83537 16.3877 6.97296 16.4461 7.14112C16.5045 7.30929 16.5154 7.48127 16.4789 7.65708C16.4424 7.83289 16.3512 7.98958 16.2052 8.12717L12.9858 11.0395L13.9495 15.3735C13.9933 15.5722 13.9787 15.7519 13.9057 15.9124C13.8327 16.0729 13.7305 16.2067 13.5991 16.3137C13.4677 16.4207 13.3144 16.4818 13.1392 16.4971C12.9639 16.5124 12.796 16.4666 12.6354 16.3595L9 14.0664Z"
        fill={`url(#${gradientId})`}
      />
      <defs>
        <linearGradient id={gradientId} x1="1.5" y1="1.5" x2="16.5" y2="16.5" gradientUnits="userSpaceOnUse">
          <stop stopColor={getHexColor(color1)} />
          <stop offset="1" stopColor={getHexColor(color2)} />
        </linearGradient>
      </defs>
    </svg>
  )
}
